(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // VL variant cards: size buttons switch the card's image, price, sold-out badge and links.
  document.addEventListener('click', (event) => {
    const chip = event.target instanceof Element ? event.target.closest('[data-vl-size]') : null;
    if (!chip) return;
    const card = chip.closest('.vl-vcard');
    if (!card) return;

    for (const other of card.querySelectorAll('[data-vl-size]')) {
      other.setAttribute('aria-pressed', String(other === chip));
    }

    const image = card.querySelector('.vl-vcard__image');
    if (image instanceof HTMLImageElement && chip.dataset.image) {
      image.srcset = chip.dataset.srcset || '';
      image.src = chip.dataset.image;
    }

    const price = card.querySelector('[data-vl-price]');
    if (price) price.textContent = chip.dataset.price || '';
    const compare = card.querySelector('[data-vl-compare]');
    if (compare instanceof HTMLElement) {
      compare.textContent = chip.dataset.compare || '';
      compare.hidden = !chip.dataset.compare;
    }
    const soldOut = card.querySelector('[data-vl-soldout]');
    if (soldOut instanceof HTMLElement) soldOut.hidden = chip.dataset.available === 'true';

    for (const link of card.querySelectorAll('[data-vl-card-link]')) {
      if (link instanceof HTMLAnchorElement && chip.dataset.url) link.href = chip.dataset.url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
